import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { ClarityService } from './clarity.service';

export function provideClarity(enabled: boolean, key: string): EnvironmentProviders[] {
  if (!enabled) {
    return [];
  }

  return [
    provideAppInitializer(() => {
      const clarityService = inject(ClarityService);

      clarityService.initialize(key);
    }),
  ];
}
